import {useContext, useMemo} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import SelectRange, {FIELD_NAME} from '@adv-mt/mt-form-select-range'

import useLabel from './hooks/useLabel.js'

const LEGACY_WRAPPER = 'legacy'

const FormHp = ({
  initialSearch,
  isInline,
  onChange,
  overlayContentRef,
  pageName = '',
  type,
  value = {},
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)
  const {labelFormatter} = useLabel({categoryId: initialSearch.categoryId, value: value.from})

  const config = domain.get('config')
  const {hp, DEFAULT_HP_MIN, FILTER_NAMES} = config.get('search')

  const currentValue = {
    from: value.from || DEFAULT_HP_MIN,
    to: value.to || DEFAULT_HP_MIN
  }

  const options = useMemo(
    () =>
      hp.map(hpValue => ({
        id: hpValue,
        label: labelFormatter({value: hpValue})
      })),
    [hp, labelFormatter]
  )

  return (
    <div className="mt-FormHp">
      <SelectRange
        fieldName={FILTER_NAMES.HP}
        formatterLabel={labelFormatter}
        initialSearch={initialSearch}
        isInline={isInline}
        label={i18n.t('COMMON_POWER')}
        onChange={onChange}
        options={{
          from: {
            name: FIELD_NAME.FROM,
            options
          },
          to: {
            name: FIELD_NAME.TO,
            options
          }
        }}
        overlayContentRef={overlayContentRef}
        pageName={pageName}
        type={type}
        value={currentValue}
        wrapper={wrapper}
      />
    </div>
  )
}

const FormHpInline = props => <FormHp {...props} isInline />
FormHpInline.displayName = 'FormHpInline'

FormHp.displayName = 'FormHp'
FormHp.propTypes = {
  initialSearch: PropTypes.object,
  isInline: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  pageName: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  wrapper: PropTypes.string
}

export {FormHpInline}

export default FormHp
